module.exports = __webpack_public_path__ + "media/duel_in_the_mist.0c0b09ed.mp3";